
import { PropType, Ref, computed, defineComponent, onMounted, provide, ref } from 'vue';

import {
  RUSSIAN_SOFTWARE_REGISTRY_DESCRIPTION,
  RUSSIAN_SOFTWARE_REGISTRY_HREF,
} from 'SharedDir/constants/software-registry';

export default defineComponent({
  name: 'ComponentName',
  props: {
    width: {
      type: String as PropType<string>,
      default: '196px',
    },
  },
  setup() {
    onMounted(async () => {});

    return {
      RUSSIAN_SOFTWARE_REGISTRY_HREF,
      RUSSIAN_SOFTWARE_REGISTRY_DESCRIPTION,
    };
  },
});
